// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pNB3AnUsAmJc7IauC1JA{border-radius:0!important}._amMV25xtYpwPBKiphWe{margin-right:-20px;padding-bottom:5px;overflow:hidden}.B48TtVb20OMgkLdXjRSf{flex-direction:column;padding-right:20px;display:flex}.nEDE_m44J38RJ45_TleD{max-height:100%!important}.QHdWLXBMdG0XltYv4Tby{background:var(--background-neutral-subtle)}.QHdWLXBMdG0XltYv4Tby .g0TATuiK0oS_x2OYlvPY{background:var(--border-neutral-primary);margin:0 20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWrap": `pNB3AnUsAmJc7IauC1JA`,
	"scrollbarWrap": `_amMV25xtYpwPBKiphWe`,
	"scrollbar__content": `B48TtVb20OMgkLdXjRSf`,
	"scrollbarContent": `B48TtVb20OMgkLdXjRSf`,
	"scrollbar__view": `nEDE_m44J38RJ45_TleD`,
	"scrollbarView": `nEDE_m44J38RJ45_TleD`,
	"dividerWrap": `QHdWLXBMdG0XltYv4Tby`,
	"divider": `g0TATuiK0oS_x2OYlvPY`
};
export default ___CSS_LOADER_EXPORT___;
